export default __webpack_public_path__ + "static/media/Luna.5cfaea5f.png";